<ng-template #eyeOpen>
  <svg
    class="w-6 h-6 hover:text-blue-500 text-gray-800 dark:text-white"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      stroke="currentColor"
      stroke-width="2"
      d="M21 12c0 1.2-4.03 6-9 6s-9-4.8-9-6c0-1.2 4.03-6 9-6s9 4.8 9 6Z"
    />
    <path
      stroke="currentColor"
      stroke-width="2"
      d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
    />
  </svg>
</ng-template>
<ng-template #eyeSlash>
  <svg
    class="w-6 h-6 hover:text-blue-500 text-gray-800 dark:text-white"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M3.933 13.909A4.357 4.357 0 0 1 3 12c0-1 4-6 9-6m7.6 3.8A5.068 5.068 0 0 1 21 12c0 1-3 6-9 6-.314 0-.62-.014-.918-.04M5 19 19 5m-4 7a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
    />
  </svg>
</ng-template>

@if (!verificationMode) {
  <!-- Login Section -->
  <section class="bg-gray-50 dark:bg-gray-900">
    <!-- Login Section Container -->
    <div
      class="flex flex-col items-center justify-center px-6 py-8 mx-auto md:h-screen lg:py-0"
    >
      <!-- Logo of Product -->
      <a
        href="#"
        class="flex items-center mb-6 text-2xl font-semibold text-gray-900 dark:text-white"
      >
        @if (themeService.darkMode$ | async) {
          <img
            src="/assets/svg/LIQ_DDA_dark.svg"
            class="h-8"
            alt="Flowbite Logo"
          />
        } @else {
          <img
            src="/assets/svg/LIQ_DDA_white.svg"
            class="h-8"
            alt="Flowbite Logo"
          />
        }
      </a>
      <!-- Form Container -->
      <div
        class="w-full bg-white rounded-lg shadow dark:border md:mt-0 sm:max-w-md xl:p-0 dark:bg-gray-800 dark:border-gray-700"
      >
        <!-- Form Container -->
        <div class="p-6 space-y-4 md:space-y-6 sm:p-8">
          <!-- Form Title-->
          <h1
            class="text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl dark:text-white"
          >
            Sign in to your account
          </h1>
          <!-- Error message -->
          @if (errorMessage) {
            <div
              class="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded"
              role="alert"
            >
              {{ errorMessage }}
            </div>
          }
          <!-- Form Content -->
          <form
            class="flex flex-col gap-3 md:gap-4"
            [formGroup]="loginForm"
            (ngSubmit)="login()"
          >
            <div>
              <label
                for="email"
                class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                >Your email</label
              >
              <input
                type="email"
                id="email"
                formControlName="email"
                class="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                placeholder="name@email.com"
                required
                [ngClass]="{
                  'border-red-600 focus:border-red-600 focus:ring-red-600':
                    getInputErrorMessage('email') !== null,

                  'border-gray-300 focus:border-primary-600 focus:ring-primary-600':
                    getInputErrorMessage('email') === null,
                }"
              />
              <div
                class="text-red-600 text-nowrap text-sm min-h-5 ps-1"
                [ngClass]="{
                  invisible: getInputErrorMessage('email') === null,
                }"
              >
                {{ getInputErrorMessage("email") }}
              </div>
            </div>
            <div>
              <label
                for="password"
                class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                >Password</label
              >
              <div class="relative flex flex-row items-center">
                <input
                  [type]="showPassword ? 'text' : 'password'"
                  id="password"
                  formControlName="password"
                  placeholder="••••••••"
                  class="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 pr-10 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  required
                  [ngClass]="{
                    'border-red-600 focus:border-red-600 focus:ring-red-600':
                      getInputErrorMessage('password') !== null,

                    'border-gray-300 focus:border-primary-600 focus:ring-primary-600':
                      getInputErrorMessage('password') === null,
                  }"
                />
                <button
                  type="button"
                  [title]="showPassword ? 'Hide password' : 'Show password'"
                  class="absolute right-2"
                  (click)="showPassword = !showPassword"
                >
                  <ng-container
                    [ngTemplateOutlet]="showPassword ? eyeOpen : eyeSlash"
                  ></ng-container>
                </button>
              </div>
              <div
                class="text-red-600 text-nowrap text-sm min-h-5 ps-1"
                [ngClass]="{
                  invisible: getInputErrorMessage('password') === null,
                }"
              >
                {{ getInputErrorMessage("password") }}
              </div>
            </div>
            <div class="flex items-center justify-between">
              <div class="flex items-start">
                <div class="flex items-center h-5">
                  <input
                    id="remember"
                    aria-describedby="remember"
                    type="checkbox"
                    class="w-4 h-4 border border-gray-300 rounded bg-gray-50 focus:ring-3 focus:ring-primary-300 dark:bg-gray-700 dark:border-gray-600 dark:focus:ring-primary-600 dark:ring-offset-gray-800"
                    required
                  />
                </div>
                <div class="ml-3 text-sm">
                  <label for="remember" class="text-gray-500 dark:text-gray-300"
                    >Remember me</label
                  >
                </div>
              </div>
              <a
                class="text-sm font-medium text-primary-600 text-gray-500 hover:underline dark:text-primary-500 dark:text-white cursor-pointer"
                (click)="directTo('forgot-password')"
                >Forgot password?</a
              >
            </div>
            <button
              type="submit"
              class="w-full text-white bg-blue-600 hover:bg-blue-700 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800 cursor-pointer"
            >
              Sign in
            </button>
            <p class="text-sm font-light text-gray-500 dark:text-gray-400">
              Don't have an account yet?
              <a
                class="font-medium text-primary-600 hover:underline dark:text-primary-500 cursor-pointer"
                (click)="directTo('signup')"
                >Sign up</a
              >
            </p>
          </form>
        </div>
      </div>
    </div>
  </section>
} @else {
  <section class="bg-gray-50 dark:bg-gray-900">
    <!-- Signup Container -->
    <div
      class="flex flex-col items-center justify-center px-6 py-8 mx-auto md:h-screen lg:py-0"
    >
      <!-- Logo Section -->
      <a
        href="#"
        class="flex items-center mb-5 text-2xl font-semibold text-gray-900 dark:text-white"
      >
        @if (themeService.darkMode$ | async) {
          <img
            src="/assets/svg/LIQ_DDA_dark.svg"
            class="h-8"
            alt="Flowbite Logo"
          />
        } @else {
          <img
            src="/assets/svg/LIQ_DDA_white.svg"
            class="h-8"
            alt="Flowbite Logo"
          />
        }
      </a>
      <!-- Main Content -->
      <div
        class="w-full bg-white rounded-lg shadow dark:border md:mt-0 sm:max-w-md xl:p-0 dark:bg-gray-800 dark:border-gray-700"
      >
        <!-- Content Container -->
        <div class="p-6 space-y-2 md:space-y-2 sm:p-8 relative">
          <!-- Back Button -->
          <button
            type="button"
            (click)="goBackToLogin()"
            class="absolute top-4 left-4 flex items-center space-x-1 text-sm text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 focus:outline-none transition-all"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="w-4 h-4"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              stroke-width="2"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M15 19l-7-7 7-7"
              />
            </svg>
            <span>Back</span>
          </button>

          <!-- Title -->
          <h1
            class="text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl dark:text-white text-center"
          >
            Check Your Email
          </h1>

          <!-- Subtitle -->
          <p class="text-sm text-gray-500 dark:text-gray-400 text-center mb-4">
            A verification code has been sent to your email. Please enter it
            below to complete your sign-in.
          </p>
          <!-- Error message -->
          @if (errorMessage) {
            <div
              class="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded"
              role="alert"
            >
              {{ errorMessage }}
            </div>
          }
          <!-- Form Content -->
          <form
            class="space-y-4 md:space-y-5"
            [formGroup]="verificationForm"
            (ngSubmit)="verifyCode()"
          >
            <!-- Verification Code -->
            <div>
              <label
                for="verification_code"
                class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                >Verification Code</label
              >
              <input
                type="text"
                id="verification_code"
                class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                placeholder="123456"
                formControlName="verification_code"
                required
                [ngClass]="{
                  'border-red-600 focus:border-red-600 focus:ring-red-600':
                    getVerificationCodeErrorMessage() !== null,

                  'border-gray-300 focus:border-primary-600 focus:ring-primary-600':
                    getVerificationCodeErrorMessage() === null,
                }"
              />
              <div
                class="text-red-600 text-nowrap text-sm min-h-5 ps-1"
                [ngClass]="{
                  invisible: getVerificationCodeErrorMessage() === null,
                }"
              >
                {{ getVerificationCodeErrorMessage() }}
              </div>
            </div>

            <div class="flex items-start">
              <div class="flex items-center h-5">
                <input
                  id="trust_device"
                  aria-describedby="trust_device"
                  type="checkbox"
                  class="w-4 h-4 border border-gray-300 rounded bg-gray-50 focus:ring-3 focus:ring-primary-300 dark:bg-gray-700 dark:border-gray-600 dark:focus:ring-primary-600 dark:ring-offset-gray-800"
                  formControlName="trust_device"
                  required
                />
              </div>
              <div class="ml-3 text-sm">
                <label
                  for="trust_device"
                  class="text-gray-500 dark:text-gray-300"
                  >Trust This Device For Two Weeks</label
                >
              </div>
            </div>

            <div class="flex items-center justify-between space-x-3">
              <button
                type="submit"
                class="w-2/3 text-white bg-blue-600 hover:bg-blue-700 focus:ring-2 focus:outline-none focus:ring-blue-100 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
              >
                Continue
              </button>
              <button
                type="button"
                [disabled]="isResendDisabled"
                (click)="resendCode()"
                class="w-1/3 text-blue-600 border border-blue-600 hover:bg-blue-50 dark:hover:bg-gray-700 font-medium rounded-lg text-sm px-5 py-2.5 text-center focus:outline-none focus:ring-2 focus:ring-blue-100 dark:text-blue-400 dark:border-blue-400 dark:focus:ring-blue-800 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-transparent"
              >
                {{
                  isResendDisabled ? "Resend (" + countdown + "s)" : "Resend"
                }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </section>
}
